module.exports = __webpack_public_path__ + "img/coffeetogomiddlesize.84c6a2fd.jpg";